import env from '../config/env';
import * as realApi from '../api/real/productsApi';
import { brands as mockBrandList, getBrandsAlphabetically as mockGetAlpha } from '../data/mockBrands';

const logApiError = (fn, err) => {
  if (process.env.NODE_ENV !== 'production') {
    console.warn(
      `%c[brandService] ${fn}: ${err?.message ?? err}`,
      'color:#F59E0B;font-weight:bold'
    );
  }
};

export const getBrands = async () => {
  if (env.isMock) return mockBrandList;
  try {
    return await realApi.getBrands();
  } catch (err) {
    logApiError('getBrands', err);
    return [];
  }
};

export const getBrandsAlphabetically = async () => {
  if (env.isMock) return mockGetAlpha();
  try {
    const list = await realApi.getBrands();
    const grouped = {};
    list.forEach((brand) => {
      const letter = (brand.name || '?')[0].toUpperCase();
      if (!grouped[letter]) grouped[letter] = [];
      grouped[letter].push(brand);
    });
    return grouped;
  } catch (err) {
    logApiError('getBrandsAlphabetically', err);
    return {};
  }
};
